/**
 * Extract the lower most subdomain from the window object
 */
const getCurrentSubdomain = () =>
  window.location.host.split('.')[1]
    ? window.location.host.split('.')[0]
    : null;

export default getCurrentSubdomain;
